@if(show() === true){
<div role="alert"
    class="ga-notification toast-alert-gaia"
    [ngClass]="{
        'ga-notification--information': alertClass() === 'toast-info',
        'ga-notification--success': alertClass() === 'toast-success',
        'ga-notification--warning': alertClass() === 'toast-warning',
        'toast-main': alertFlashName() === alertFlashNameConst.main,
        'toast-dialog': alertFlashName() !== alertFlashNameConst.main
    }">
    <span class="ga-notification__icon">
        <img alt="" class="alert-flash-icon" [src]="'assets/images/lucide/' + (alertClass() === 'toast-success' ? '16_success' : alertClass() === 'toast-warning' ? '16_warning' : '16_info') + '.svg'" width="24" height="24" aria-hidden="true" />
    </span>
    <div class="ga-notification__content">
        <div class="ga-notification__heading">
            <span class="ga-notification__title">{{title}}</span>
            <div class="ga-notification__title-actions">
                <button type="button" class="close" (click)="close()" [attr.aria-label]="closeLabel">
                    <img alt="" src="assets/images/lucide/24_close.svg" width="20" height="20" aria-hidden="true" />
                </button>
            </div>
        </div>
        <div class="ga-notification__description">
            <p>{{text()}}</p>
        </div>
    </div>
</div>
}
